import { Copy, Fingerprint } from "lucide-react";
import { toast } from "sonner";
import { useMyPortalId } from "@/hooks/platform/useAgency";

interface Props {
  /** Short portal code for the workspace, e.g. CM / VO / PC */
  portalCode: string;
  /** Optional explicit id (falls back to the signed-in staff member's portal id) */
  value?: string | null;
}

const PortalIdBadge = ({ portalCode, value }: Props) => {
  const { data } = useMyPortalId();
  const id = value ?? data?.portal_id ?? "—";
  const full = `${portalCode}·${id}`;

  return (
    <button
      type="button"
      onClick={() => {
        navigator.clipboard?.writeText(full);
        toast.success("Portal ID copied");
      }}
      className="group inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-3 py-1.5 text-xs font-mono text-white hover:bg-white/10 transition-colors"
      title="Copy portal ID"
    >
      <Fingerprint className="h-3.5 w-3.5 text-gray-400" />
      <span className="tracking-wider">{full}</span>
      <Copy className="h-3 w-3 text-gray-500 group-hover:text-white" />
    </button>
  );
};

export default PortalIdBadge;
